import {
  NBS_API_CONTACT_US_REQUEST,
  NBS_API_CONTACT_US_SUCCESS,
  NBS_API_CONTACT_US_FAILURE
} from '../../constants/actions';
import nbsApi from '../../assets/helpers/nbsApi';
import strings from '../../assets/localization';

function nbsApiContactUsRequest () {
  return { type: NBS_API_CONTACT_US_REQUEST };
}
function nbsApiContactUsSuccess (response) {
  return {
    type: NBS_API_CONTACT_US_SUCCESS,
    response
  };
}
function nbsApiContactUsError (error) {
  return {
    type: NBS_API_CONTACT_US_FAILURE,
    error: error.cause || error
  };
}
export function nbsApiContactUs (data) {
  const url = 'contactUs';
  if (!data.language && strings.getLanguage()) {
    data.language = strings.getLanguage();
  }
  return dispatch => {
    dispatch(nbsApiContactUsRequest());
    return nbsApi(url, data)
      .then(response => dispatch(nbsApiContactUsSuccess(response)))
      .catch(error => dispatch(nbsApiContactUsError(error)));
  };
}
